module.exports = __webpack_public_path__ + "img/37863-014.ae793ddf.jpg";